/* eslint-disable no-console */
import React from 'react';

import { createRoot } from 'react-dom/client';
import { InitSentry } from 'src/services/SentryService';

import { initHubspotClient } from './services/analytics/HubspotService';
import { AppContainer } from './AppContainer';

import './index.css';

// Init hubspot
initHubspotClient();

// Init Sentry
InitSentry();

console.log(`Current UI Version is: ${UI_VERSION}`);

// Type assertion for getElementById since we know 'root' exists
const rootElement = document.getElementById('root');
if (!rootElement) {
	throw new Error('Root element not found');
}

const root = createRoot(rootElement);
root.render(<AppContainer />);
